import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'cookies_accepted';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only show if not already accepted
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) setShow(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        background: '#222',
        color: '#fff',
        padding: '18px 12px',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 -1px 8px rgba(0,0,0,0.2)'
      }}
    >
      <span>
        This website uses cookies to enhance the user experience. By continuing, you accept our use of cookies.
      </span>
      <button
        onClick={handleAccept}
        style={{
          marginLeft: 16,
          background: '#4197f1',
          color: '#fff',
          border: 'none',
          padding: '7px 18px',
          borderRadius: 5,
          cursor: 'pointer',
          fontWeight: 500,
          fontSize: 16
        }}
      >
        Allow Cookies
      </button>
    </div>
  );
};

export default CookieConsent;
